import {
	Button, Dialog, DialogActions, DialogContent, DialogContentText,
	DialogTitle, Tooltip
} from '@material-ui/core';
import React, { useState } from 'react';
import { useActions, useValues } from 'kea';

import geofencelogic from 'src/store/geofence';



const RemoveGeofenceDialog = ({ geofence, reset }) => {
	const [open, setOpen] = useState(false);

	const { remove } = useActions(geofencelogic);

	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
	}

	const handleRemove = () => {
		let validated = true;
		if (!geofence) {
			validated = false;
		}
		if (validated) {
			remove(geofence);
			reset();
			setOpen(false);
		}
	}

	return (
		<div>
			<Tooltip title="Remove selected geofence">
				<div style={{ paddingLeft: '22px', paddingTop: '5px' }}>
					<Button
						color="default"
						variant="contained"
						aria-label="add"
						onClick={handleClickOpen}
						size='large'
					>
						Remove
					</Button>
				</div>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="geofence-dialog-title"
				aria-describedby="geofence-dialog-description"
			>
				<DialogTitle id="geofence-dialog-title">
					{"Remove Geofence?"}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="geofence-dialog-description">
						Remove the Geofence?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleRemove} color="primary">
						Confirm Remove
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}


export default RemoveGeofenceDialog
